import dayjs from 'dayjs';

import { relativeParkedAt } from './nonRoutableRequestDates';

/**
 * POM-6279 — "3 days ago" for a parked row, measured on the DATABASE clock.
 *
 * The queue item serves `ageSeconds` (seconds since the park, by the database clock), so the age an
 * operator triages on does not drift with a workstation clock that is wrong. It is rendered against
 * `parkedAt + ageSeconds` — the server's "now" — which keeps the familiar "x ago" wording. A row
 * without `ageSeconds` (an older response) falls back to the browser clock.
 */
const parkedAgeLabel = ({ parkedAt, ageSeconds }) => {
  if (!parkedAt) return null;
  if (!Number.isFinite(ageSeconds)) return relativeParkedAt(parkedAt);

  const parked = dayjs(parkedAt);
  if (!parked.isValid()) return null;

  return relativeParkedAt(parkedAt, parked.add(ageSeconds, 'second'));
};

export default parkedAgeLabel;
